"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _Editions = require("self-service-api/constants/Editions");

var _Hubs = _interopRequireDefault(require("self-service-api/constants/Hubs"));

var MerchandiseIds = _interopRequireWildcard(require("self-service-api/constants/MerchandiseIds"));

var _default = function _default(isInMCBeta) {
  var _STARTER, _PROFESSIONAL, _ENTERPRISE, _ref;

  return _ref = {}, (0, _defineProperty2.default)(_ref, _Editions.STARTER, (_STARTER = {}, (0, _defineProperty2.default)(_STARTER, _Hubs.default.HUB_MARKETING, isInMCBeta ? MerchandiseIds.PRODUCT_MARKETING_STARTER_MC : MerchandiseIds.PRODUCT_MARKETING_STARTER_NOV_2019), (0, _defineProperty2.default)(_STARTER, _Hubs.default.HUB_SALES, MerchandiseIds.PRODUCT_SALES_STARTER_MAR_2020), (0, _defineProperty2.default)(_STARTER, _Hubs.default.HUB_SERVICE, MerchandiseIds.PRODUCT_SERVICE_STARTER_MAR_2020), _STARTER)), (0, _defineProperty2.default)(_ref, _Editions.PROFESSIONAL, (_PROFESSIONAL = {}, (0, _defineProperty2.default)(_PROFESSIONAL, _Hubs.default.HUB_MARKETING, isInMCBeta ? MerchandiseIds.PRODUCT_MARKETING_PROFESSIONAL_MC : MerchandiseIds.PRODUCT_MARKETING_PROFESSIONAL), (0, _defineProperty2.default)(_PROFESSIONAL, _Hubs.default.HUB_SALES, MerchandiseIds.PRODUCT_SALES_PROFESSIONAL_NOV_2019), (0, _defineProperty2.default)(_PROFESSIONAL, _Hubs.default.HUB_SERVICE, MerchandiseIds.PRODUCT_SERVICE_PROFESSIONAL), (0, _defineProperty2.default)(_PROFESSIONAL, _Hubs.default.HUB_CMS, MerchandiseIds.PRODUCT_CMS_PROFESSIONAL), _PROFESSIONAL)), (0, _defineProperty2.default)(_ref, _Editions.ENTERPRISE, (_ENTERPRISE = {}, (0, _defineProperty2.default)(_ENTERPRISE, _Hubs.default.HUB_MARKETING, isInMCBeta ? MerchandiseIds.PRODUCT_MARKETING_ENTERPRISE_MC : MerchandiseIds.PRODUCT_MARKETING_ENTERPRISE), (0, _defineProperty2.default)(_ENTERPRISE, _Hubs.default.HUB_SALES, MerchandiseIds.PRODUCT_SALES_ENTERPRISE), (0, _defineProperty2.default)(_ENTERPRISE, _Hubs.default.HUB_SERVICE, MerchandiseIds.PRODUCT_SERVICE_ENTERPRISE), (0, _defineProperty2.default)(_ENTERPRISE, _Hubs.default.HUB_CMS, MerchandiseIds.PRODUCT_CMS_ENTERPRISE), _ENTERPRISE)), _ref;
};

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/constants/SuiteEditionMerchIdMap.js
// module id = 76
// module chunks = 5 6 7